module.exports = __webpack_public_path__ + "static/media/weathericons-regular-webfont.ecaf8b48.svg";